// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","modal_text":"Modal_modal_text__xlKIl","red":"Modal_red__pDcx-","green":"Modal_green__BL2Pr","purple":"Modal_purple__erQ5e","grey":"Modal_grey__2zDGC"};